import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FullPageSpinner      from '../Fragments/FullPageSpinner';
import { browserHistory }   from 'react-router';

let HttpService = require('../Managers/HttpService');
let envConfig;
let Quote =  require('../Managers/Quote');

class ErrorScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorTitle: 'Not found',
            errorMessage: null,
            logError: false,
            isFullPageSpinnerActive: false,
            uploadedFiles: [],
            retryCounter: 0,
        };
    }

    componentWillMount() {
        // Clear any prior errors
        window.localStorage.removeItem('Error');

        if (this.props.params.type) {
            switch(this.props.params.type) {
                case 'no-auth':
                    this.setState({
                        errorTitle: 'Unauthorised access',
                        errorMessage: 'You were unsuccessful in authorising against our server.',
                    });
                    break;
                case 'no-application':
                    this.setState({
                        errorTitle: 'Cannot find application',
                        errorMessage: 'We were unable to find that application ID in our system.'
                    });
                    break;
                case 'cannot-submit-case':
                    this.setState({
                        errorTitle: 'Missing details to start referencing',
                        errorMessage: 'One or more vital pieces of information is missing in order for us to begin the referencing process.',
                        logError: true,
                    });
                    break;
                case 'agent-email-to-tenant':
                    this.setState({
                        errorTitle: 'Error during Email to Tenant Process',
                        errorMessage: 'There was an internal server error during the email to tenant process.'
                    });
                    break;
                case 'agent-complete-now':
                    this.setState({
                        errorTitle: 'Error during Complete Now Process',
                        errorMessage: 'There was an internal server error during the complete now process.'
                    });
                    break;
                case 'validation-failed':
                    this.setState({
                        errorTitle: 'Error validating your application details',
                        errorMessage: "There was an error when validating your details."
                    });
                    break;
                case 'save-application-details':
                    this.setState({
                        errorTitle: 'Error saving application details',
                        errorMessage: "There was an error when saving your details.",
                        logError: true,
                    });
                    break;
                case 'save-notes':
                    this.setState({
                        errorTitle: 'Error saving application notes',
                        errorMessage: "There was an error when saving the application notes."
                    });
                    break;
                case 'submit-application':
                    this.setState({
                        errorTitle: 'Error submitting the application',
                        errorMessage: "There was an error when submitting the application.",
                        logError: true,
                    });
                    break;
                case 'file-upload-failed':
                    this.setState({
                        errorTitle: 'Error uploading documents',
                        errorMessage: 'There was an error when uploading the documents you attached to your application. This could be because the connection was interrupted.'
                    });
                    break;
                case 'validation':
                    this.setState({
                        errorTitle: 'Validation Failed',
                        errorMessage: 'Validation checks failed.'
                    });
                    break;
                case 'applicant-validation':
                    this.setState({
                        errorTitle: 'Validation Failed',
                        errorMessage: 'There was an error validating details for the application.',
                        logError: true,
                    });
                    break;
                case 'agent-submission':
                    this.setState({
                        errorTitle: 'Validation Failed',
                        errorMessage: 'There was an error with the submission of the referencing case.',
                        logError: true,
                    });
                    break;
                case 'domain-info':
                    this.setState({
                        errorTitle: 'Domain Info Load Failed',
                        errorMessage: 'There was an error when trying to load the necessary information about your agent.'
                    });
                    break;
                case 'no-referee-type':
                    this.setState({
                        errorTitle: 'No referee type',
                        errorMessage: 'No referee type ws provided for this reference and we are unable to continue with your request.'
                    });
                    break;
                case 'save-referee-details':
                    this.setState({
                        errorTitle: 'Failed saving referee details',
                        errorMessage: 'There was an error while saving the referee details.'
                    });
                    break;
                case 'invalid-referee-type':
                    this.setState({
                        errorTitle: 'Invalid referee type',
                        errorMessage: 'An invalid referee type was provided for this reference and we are unable to continue.'
                    });
                    break;
                default:
                    this.setState({
                        errorTitle: 'Resource not found',
                        errorMessage: 'The page or resource you are trying to access cannot be found.'
                    });
                    break;
            }
        }

        // Increment the number of retries attempted
        let newRetryCounter = parseInt(window.localStorage.getItem('retryCounter')) + 1;
        window.localStorage.setItem('retryCounter', newRetryCounter);

        envConfig = HttpService.getConfigForHost();
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);

        // Logging of errors is controlled by state
        if (true === this.state.logError) {
            this.createErrorLog();
        }
    }

    /**
     * Set up all the data to log the error and push the HttpService method to
     * save it.
     */
    createErrorLog() {
        // Get and set the user IP
        HttpService.getIp('Error.ip');

        // Build up additional error data
        Quote.setByPath('Error.referenceNumber', Quote.getByPath('BaseIndividualApplication.referenceNumber'));
        Quote.setByPath('Error.type', this.props.params.type);
        Quote.setByPath('Error.title', this.state.errorTitle);
        Quote.setByPath('Error.message', this.state.errorMessage);
        Quote.setByPath('Error.userAgent', window.navigator.userAgent);

        HttpService.logError(window.localStorage.getItem('Error'));
    }

    fileUploaded(file) {
        // use the file to print out a filename somewhere
        let uploadedFiles = this.state.uploadedFiles.concat([file]);
        this.setState({ uploadedFiles });
    }

    retryPutApplicationAndSubmit() {
        switch (this.props.params.type) {
            case 'agent-email-to-tenant':
            case 'agent-complete-now':
                HttpService.agentGeneralisedSubmitProcess(() => {
                    this.setState({ isFullPageSpinnerActive: false });
                    window.localStorage.removeItem('validationError');
                    browserHistory.push('/case/submitted');
                }, (invalidData) => {
                    window.localStorage.setItem('validationError', JSON.stringify(invalidData));
                    browserHistory.push('/error/validation');
                });
                break;
            default:
            HttpService.applicationPutApplicationAndSubmit();
                break;
        }
    }

    resendFiles() {
        this.setState({ isFullPageSpinnerActive: true });
        HttpService.sendFilesForApplication((file) => { this.fileUploaded(file); });
    }

    tryAgain(event) {
        event.preventDefault();
        history.go(-1);
        window.location.reload();
    }

    render() {
        let fileNumber = 0;
        let files = JSON.parse(window.localStorage.getItem('GlobalFileList'));
        if( ! window.uorn(files)) {
            files.map(() => {
                fileNumber = fileNumber + 1;
            });
        }

        let errorArray = [];
        let errorResponse = JSON.parse(window.localStorage.getItem('errorArray'));
        if (errorResponse) {
            for (let v in errorResponse) {
                errorArray.push((errorResponse[v]));
            }
        }

        let error = JSON.parse(window.localStorage.getItem('validationError'));
        let errorList = [];

        if (!window.uornorb(error)) {
            Quote.setByPath('Error.params', error.errors);
            errorList = $.map(error.errors, function(el) {
                return <li key={el}>{el}</li>;
            });
        }

        return(
            <div>
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                    header={"Uploading Files"}
                />

                <question-row class="header-row">
                    <div className="question-top">
                        <h1>{this.state.errorTitle}</h1>
                        <p>There was an error that is preventing you from continuing any further. {this.state.errorMessage ? <span>The message from the server is as follows:</span> : null}</p>
                        {!window.uornorb(errorResponse) ?
                            <div>
                                <p>{errorArray.toString()}</p>
                                <a href="#" className="underline" onClick={this.tryAgain.bind(this)}>Click here to go back</a>
                            </div>
                        :
                            <div>
                                {this.state.errorMessage && errorList.length <= 0 ?
                                    <p>{this.state.errorMessage}</p>
                                : null}

                                {errorList.length >= 1 ?
                                    <ul>
                                        {errorList}
                                    </ul>
                                : null}
                            </div>
                        }

                        {parseInt(window.localStorage.getItem('retryCounter')) > 3 ?
                            <p>If you would like further assistance with this, please contact us on {Quote.getByPath('domainInfo.generalTelephone')}, or email <a href={'mailto:' + Quote.getByPath('domainInfo.generalEmail')}>{Quote.getByPath('domainInfo.generalEmail')}</a>, letting us know what you were doing when you received this error.{ ! Quote.getByPath('BaseIndividualApplication.referenceNumber') ? <span>Alternatively, <a href={envConfig.connectUrl.url}>click here</a> to return to Connect.</span> : null}</p>
                        :
                            <div>
                                {/* Error validation application - let the user  retry */}
                                {errorList.length >= 1 ?
                                    <p><a href="#" className="btn btn-success btn-inline" onClick={() => {
                                            history.go(-1);
                                        }}>Click here to go back</a></p>
                                : null}

                                {errorList.length <= 0 || window.uornorb(errorList) && (this.props.params.type === 'validation-failed' || this.props.params.type === 'save-application-details' || this.props.params.type === 'save-notes' || this.props.params.type === 'submit-application' || this.props.params.type === 'file-upload-failed' || this.props.params.type === 'applicant-validation' || this.props.params.type === 'agent-submission') ?
                                    <p><a href="#" className="btn btn-success btn-inline" onClick={this.retryPutApplicationAndSubmit.bind(this)}>Click here to retry</a></p>
                                : null}
                            </div>
                        }
                    </div>
                </question-row>
            </div>
        );
    }
}

ErrorScreen.propTypes = {
    params: PropTypes.object,
};

export default ErrorScreen;


// WEBPACK FOOTER //
// ./src/components/Screens/Error.js